/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ButtonCTAComponentEditor } from "cms/components/components/button-cta/edit";
import { ButtonCTAComponentDisplay } from "cms/components/components/button-cta/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const ButtonCTAComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <ButtonCTAComponentDisplay />,
        editComponent: <ButtonCTAComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ButtonCTAComponent.displayName = "ButtonCTAComponent";
export { ButtonCTAComponent };
